import type { PropsWithChildren } from 'react';

import { SectionHeader } from '@/components/SectionHeader';
import type { ContentfulPlaceholderFragment } from '@/graphql/contentful/api';

import * as S from './Header.styles';

interface HeaderProps extends PropsWithChildren {
  heading: ContentfulPlaceholderFragment['heading'];
}

export const Header = ({ children, heading }: HeaderProps) => {
  return (
    <S.Header data-test-id='Header'>
      {heading && (
        <>
          <S.TitleMobile data-test-id='HeaderTitleMobile'>
            {heading}
          </S.TitleMobile>
          <S.TitleDesktop data-test-id='HeaderTitleDesktop'>
            <SectionHeader disableGutters htmlElementTag='h2' text={heading} />
          </S.TitleDesktop>
        </>
      )}
      {children}
    </S.Header>
  );
};
